import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface InventorySource {
  id: string;
  name: string;
  source_type: string;
  pollutant: string;
  is_odour: boolean;
  emission_rate: number;
  release_height: number;
  facility_name?: string;
  sector?: string;
  lat: number;
  lon: number;
}

export interface Inventory {
  id: string;
  name: string;
  description?: string;
  inventory_type: string;
  scenario?: string;
  source_count: number;
  created_at: string;
  updated_at: string;
}

interface InventoryState {
  inventories: Inventory[];
  selectedInventory: Inventory | null;
  sources: InventorySource[];
  updateFlag: boolean;
}

const initialState: InventoryState = {
  inventories: [],
  selectedInventory: null,
  sources: [],
  updateFlag: false,
};

export const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setInventories: (state, action: PayloadAction<Inventory[]>) => {
      state.inventories = action.payload;
    },
    setSelectedInventory: (state, action: PayloadAction<Inventory | null>) => {
      state.selectedInventory = action.payload;
    },
    setSources: (state, action: PayloadAction<InventorySource[]>) => {
      state.sources = action.payload;
    },
    triggerUpdate: (state) => {
      state.updateFlag = !state.updateFlag;
    },
  },
});

export const { setInventories, setSelectedInventory, setSources, triggerUpdate } =
  inventorySlice.actions;

export default inventorySlice.reducer;
